/** Shared remaining-payment category labels. */

export const REMAINING_PAYMENT_CATEGORY_ORDER = [
  'Membership',
  'Guest Pass',
  'Renewal Sale',
  'PT Sale',
  'Locker Sale',
  'Spa Sale',
  'Oxybar Sale',
  'Zumba Sale',
  'Yoga Sale',
  'Gym Apparel',
  'Miscellaneous Sale',
  'Remaining Clear',
  'Other',
];

const SOURCE_TO_CATEGORY = {
  subscription: 'Membership',
  subscriptions: 'Membership',
  membership: 'Membership',
  new_membership: 'Membership',
  guest_pass: 'Guest Pass',
  guestpass: 'Guest Pass',
  renewal_sale: 'Renewal Sale',
  renewal: 'Renewal Sale',
  pt_sale: 'PT Sale',
  locker_sale: 'Locker Sale',
  spa_sale: 'Spa Sale',
  oxybar_sale: 'Oxybar Sale',
  zumba_sale: 'Zumba Sale',
  yoga_sale: 'Yoga Sale',
  gym_apparel: 'Gym Apparel',
  miscellaneous_sale: 'Miscellaneous Sale',
  misc_sale: 'Miscellaneous Sale',
  remaining_clear: 'Remaining Clear',
  remaining: 'Remaining Clear',
  balance_clear: 'Remaining Clear',
  balance_payment: 'Remaining Clear',
  pay_balance: 'Remaining Clear',
};

export function remainingPaymentCategory(payment) {
  const source = String(payment?.source || '')
    .trim()
    .toLowerCase()
    .replace(/-/g, '_');
  if (source && SOURCE_TO_CATEGORY[source]) return SOURCE_TO_CATEGORY[source];
  return 'Other';
}

export function groupPendingByCategory(rows, leftFn) {
  const map = new Map();
  (rows || []).forEach((row) => {
    const category = remainingPaymentCategory(row);
    if (!map.has(category)) map.set(category, []);
    map.get(category).push(row);
  });
  return REMAINING_PAYMENT_CATEGORY_ORDER
    .filter((cat) => map.has(cat))
    .map((cat) => ({
      category: cat,
      rows: map.get(cat),
      totalLeft: map.get(cat).reduce((sum, row) => sum + leftFn(row), 0),
      count: map.get(cat).length,
    }));
}
